// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../imgs/ArrowDown.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../imgs/beneficio1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../imgs/beneficio2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../imgs/beneficio3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../imgs/beneficio4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../imgs/post1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../imgs/post2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../imgs/post3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../imgs/fashionStar/starExperience.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../imgs/fashionStar/LogoFshionW.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../imgs/encontraRevendPc.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../imgs/LogoRotate.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../imgs/encontraRevendMob.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cardo:wght@700&family=Inter:wght@400;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MOVIMENTAÇÂO CARDS */


.homePageBdy{
    width: 100vw;
    width: 100svw;
    height: 100vh;
    height: 100svh;
    max-width: 100vw;
    max-width: 100svw;
    max-height: 100vh;
    max-height: 100svh;
    overflow-x: hidden;
}
.homePage{
    min-height: 100vh;
    background-color: var(--whiteMain-color);
    color: var(--blackMain-color);
    font-family: "Poppins", sans-serif;
}



.homePage .firstContent{
    width: 100%;
    height: 90vh;
    max-height: 90vh;
    display: grid;
    grid-template-columns: 40% 60%;  
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    transition: 1s all ease-in-out;
}





.homePage .firstContent .logoText{
    width: 100%;
    font-family: "Poppins", sans-serif;
    /* font-family: 'Cardo', 'serif'; */
    font-weight: 700;
    font-size: 2.5em;
    transform: translateY(-30%);
    text-align: end;
}

.homePage .firstContent .logo{
    display: flex;
    flex-direction: column;
    margin: auto;
}

.homePage .firstContent .logoImg{
    min-width: 65vh;
    max-width: 65vh;
    align-self: center;
    aspect-ratio: 1 / 1.1513;
    background: no-repeat center / contain;
}


.homePage .firstContent .sejaRevend{
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    font-family: "Poppins", sans-serif;
    color: var(--blackMain-color);
    -webkit-user-select: none;
            user-select: none;
}

.homePage .firstContent .sejaRevend .titleSide{
    font-weight: 200;
    font-size: 3.5em;
    margin-bottom: 5px;
}

.homePage .firstContent .sejaRevend .subTitleSide{
    font-weight: 700;
    font-size: 3em;
    margin-bottom: 20px;
}

.homePage .firstContent .btnCad,
.homePage .btnCad,
.homePage .buttonSaibaMais{
    padding: 10px 30px;
    font-weight: 700;
    color: #FFFFFF;
    background-color: var(--blackMain-color);
    font-size: 2.3em;
    width: fit-content;
    border-radius: 5px;
    cursor: pointer;
    margin: 0 auto 10px auto;
    text-align: center;
}

.homePage .buttonFacaParteFashion{
    padding: 10px 30px;
    font-weight: 700;
    color: var(--blackMain-color);
    background-color: #FFFFFF;
    font-size: 1.6em;
    width: fit-content;
    border-radius: 5px;
    cursor: pointer;
    margin: 8px auto 10px auto;
}



.homePage .deslizeBaixo{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Cardo', 'serif';
    font-weight: 700;
    font-size: 1.8em;
    margin-top: 50px;
    color: #0000007a;
}


.homePage .deslizeBaixo .imagemTextDwn{
    min-width: 80px;
    max-width: 80px;
    align-self: center;
    aspect-ratio: 1/1;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center/contain;
}








/* SECOND CONTENT */

.homePage .secondContent{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 3% auto 2% auto;
    transition: all 2s;
}

.homePage .secondContent .cardBeneficio{
    height: 20vw;
    aspect-ratio: 1 / 1;
    margin: 0% auto 2% auto;
    transition: all 2s;
}

.homePage .secondContent .cardBeneficio1{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center/contain;
}

.homePage .secondContent .cardBeneficio2{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center/contain;
}


.homePage .secondContent .cardBeneficio3{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center/contain;
}

.homePage .secondContent .cardBeneficio4{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center/contain;
}




/* THIRD CONTENT */

.homePage .thirdContent{
    width: 92%;
    margin: 0px auto 50px auto;
}

.homePage .thirdContent p{
    font-family: 'Cardo', 'serif';
    font-size: 2em;
    padding: 0;
    margin: 0;
}

.homePage .thirdContent .title{
    font-family: "Poppins", sans-serif;
    font-size: 2.3em;
    font-weight: 700;
    /* text-align: center; */
}

.homePage .thirdContent .subTitle{
    font-weight: 700;
}

.homePage .thirdContent .text{
    font-weight: 500;
    margin-bottom: 15px;
    
}


.homePage  .divisorHome{
    width: 80%;
    height: 1px;
    background: var(--blackMain-color);
    background: linear-gradient(90deg, #27313733 0%, #27313766 50%, #27313733 100%);
    margin: 30px auto 20px auto;
}



.homePage  .divisorHome1{
    margin: 30px auto 20px auto;
}

.homePage  .divisorHome2{
    margin: 30px auto 20px auto;
}



.homePage .buttonSaibaMais{
    padding: 10px 30px;
    font-weight: 700;
    color: #FFFFFF;
    background-color: var(--blackMain-color);
    font-size: 1.3em;
    width: fit-content;
    border-radius: 5px;
    cursor: pointer;
    margin: 5px auto 10px auto;
}








/* FOURTH CONTENT*/

.homePage .fourthContent{
    width: 100%;
    margin: 5% auto 2% auto;
    font-family: "Poppins", sans-serif;
}


.homePage .fourthContent .title{
    font-weight: 700;
    font-size: 2em;
    text-align: center;
    width: 92%;
    margin: 0 auto 20px auto;
}


.homePage .fourthContent .contents{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    margin: 20px auto 0 auto;
}



.homePage .fourthContent .imgInsta{
    height: 25vw;
    aspect-ratio: 1 / 1;
    /* margin: 0% auto 0% auto; */
    transition: all 2s;
    cursor: pointer;
}

.homePage .fourthContent .imgInsta1{
    height: 20vw;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center/contain;
}

.homePage .fourthContent .imgInsta2{
    height: 30vw;
    aspect-ratio: 1 / 1.777;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center/contain;
}

.homePage .fourthContent .imgInsta3{
    height: 20vw;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center/contain;
}




/* FASHION CONTENT */

.homePage .FashionStars{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 60%;
    margin: 5% auto 2% auto;
    transition: all 0.5s;
    overflow: hidden;
    background-color: var(--black-experience-color);
    border: 3px solid #FFFFFF;
    color: #FFFFFF;
    padding: 50px 3% 50px 3%;
    margin: 25px auto 15px auto;
    transition: all 1s ease-in-out;
    transform: translateX(-100%);
}


.homePage .FashionStars.viewCardFashion{
    transform: translateX(0%);
}

.homePage .FashionStars .content{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
}

.homePage .FashionStars .innerBorder{
    position: absolute;
    width: 99%;
    border: 3px solid #FFFFFF;
    z-index: 10;
    height: 97%;
}


.homePage .FashionStars .starExperience{
    position: absolute;
    width: var(--sizeBubble);
    aspect-ratio: 1/1;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center/contain;
    top: var(--topBubble);
    left: var(--leftBubble);
    bottom: var(--bottomBubble);
    right: var(--rightBubble);
    z-index: 102;
    z-index: var(--zIndexBubble);
    opacity: 100%;
}


.homePage .FashionStars .content{
    position: relative;
    z-index: 110;
}

.homePage .FashionStars .logoFashion{
    width: 20vw;
    aspect-ratio: 2.252 / 1;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center/contain;
    margin: 0px auto 0px auto;
}

.homePage .FashionStars .titleFashion{
    width: 95%;
    margin: 0 auto 0px auto;
    font-family: "Poppins", sans-serif;
    font-size: 1.2em;
    font-weight: 700;
    text-align: center;
}

.homePage .FashionStars .subTitle{
    width: 90%;
    margin: 0 auto 10px auto;
    font-family: "Poppins", sans-serif;
    font-size: 1em;
    font-weight: 400;
    text-align: center;
}

.homePage .FashionStars .beneficiosCard{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    text-align: left;
    padding: 13px 10px;
    background-color: #332e309d;
    border: 1px solid #FFFFFF;
    margin: 0 auto;
}

.homePage .FashionStars .beneficio{
    display: flex;
    font-family: "Poppins", sans-serif;
    font-size: 1em;
    font-weight: 400;
    color: #E3E3E3;
    margin: 5px 0;
    max-width: 95%;
}


.homePage .FashionStars .beneficio.mid{
    font-weight: 600;
    color: #FFFFFF;
}

.homePage .FashionStars .beneficio.max{
    font-weight: 800;
    color: #FFFFFF;
}


.homePage .FashionStars .obs{
    font-family: "Poppins", sans-serif;
    font-size: 0.9em;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 10px;
    text-align: center;
}







/* FIFTH CONTENT */

.homePage .fifthContent{
    width: 100%;
    margin: 5% auto 2% auto;
    transition: all 0.5s;
}


.homePage .fifthContent .imgEncontrarRevend{
    width: 85vw;
    aspect-ratio: 3 / 1;
    /* margin: 0% auto 0% auto; */
    background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center/contain;
    transition: all 2s;
    cursor: pointer;
    margin: 0 auto;
}


/* SIXTH CONTENT */

.homePage .sixthContent{
    width: 100%;
    margin: 5% auto 2% auto;
    transition: all 0.5s;
}


.homePage .sixthContent .lojaCards{
    display: grid;
    grid-template-columns: 30% 30% 30%;
    justify-content: space-between;
    grid-gap: 50px 0;
    width: 75%;
    margin: 0 auto;
    margin-bottom: 60px;
    cursor: pointer;
}


.homePage .sixthContent .lojaCards .lojaCard{
    width: 90%;
    border: 2px solid var(--colorLojaCard);
    border-radius: 5px;
    padding: 0px 20px 30px 20px;
}

.homePage .sixthContent .lojaCards .topCard{
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
}

.homePage .sixthContent .lojaCards .logo{
    min-width: 20%;
    max-width: 20%;
    aspect-ratio: 350/111;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat center/contain;
}

.homePage .sixthContent .lojaCards .lojaTitle{
    font-family: "Poppins", sans-serif;
    /* font-family: "Playfair Display", serif; */
    font-weight: 600;
    font-size: 1.5em;
    margin: 0;
    color: var(--colorLojaCard);
}

.homePage .sixthContent .lojaCards .infoLoja{
    font-family: "Poppins", sans-serif;
    font-weight: 300;
    font-size: 1.1em;
    margin: 0;
}

.homePage .sixthContent{
    font-family: "Poppins", sans-serif;
    /* font-family: "Montserrat", sans-serif; */
    font-weight: 500;
    color: var(--blackMain-color);
}

.homePage .sixthContent .title{
    font-weight: 700;
    font-size: 2em;
    text-align: center;
}

.homePage .sixthContent .subtitle{
    font-size: 1.3em;
    width: 75%;
    margin: 15px auto 20px auto;
}




.homePage  .divisorHome5{
    margin: 30px auto 20px auto;
}

@media(max-width: 1400px){

}



@media(max-width: 767px){

    .homePage{
        min-height: 100vh;
        background-color: var(--whiteMain-color);
        color: var(--blackMain-color);
        font-family: "Poppins", sans-serif;
    }
    
    
    
    .homePage .firstContent {
        display: flex;
        flex-direction: column-reverse;
        height: fit-content;
        /* min-height: 88vh; */
        /* margin: 30px auto 8vh auto; */
        margin: 0px auto 50px auto;
        justify-content: flex-end;
        padding-top: 4vh;
    }

    .homePage .firstContent .logoImg {
        min-width: 35vh;
        max-width: 35vh;
    }

    .homePage .firstContent .logo {
       margin: 0;
    }

    .homePage .firstContent .sejaRevend .titleSide {
        font-size: 1.7em;
    }

    .homePage .firstContent .sejaRevend .subTitleSide {
        font-size: 1em;
        width: 80%;
    }
    .homePage .firstContent .btnCad,
    .homePage .btnCad{
        font-size: 1.1em;
        margin-bottom: 30px;
    }




    .homePage  .divisorHome1,
    .homePage  .divisorHome2,
    .homePage  .divisorHome3,
    .homePage  .divisorHome4,
    .homePage  .divisorHome5{
        margin: 0px auto 5px auto;
    }

    /* SECOND CONTENT */

    .homePage .secondContent{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 95%;
        margin: 3% auto 50px auto;
        transition: all 2s;
        overflow-x: scroll;
    }
    
    .homePage .secondContent .cardBeneficio {
        aspect-ratio: 44 / 65;
        height: 75vw;
        margin: 0% 5px 0% 5px;
        transition: all 2s;
    }



    /* THIRD CONTENT */
    .homePage .thirdContent{
        margin-top: 0;
    }


    .homePage .thirdContent p{
        /* font-family: 'Cardo', 'serif'; */
        font-family: "Poppins", sans-serif;
        font-size: 1.2em;
    }

    .homePage .thirdContent .title{
        margin-bottom: 5px;
    }

    


 
    /* FORTH */
    .homePage .fourthContent .title{
        text-align: center;
    }

    .homePage .fourthContent .title{
        font-weight: 700;
        font-size: 2em;
        text-align: center;
        width: 92%;
        margin: 0 auto 20px auto;
    }
    
    
    .homePage .fourthContent .contents{
        width: 100%;
        margin: 20px auto 0 auto;
    }

    .homePage .fourthContent .imgInsta{
        height: unset;
    }

    .homePage .fourthContent .imgInsta1{
        width: 33vw;
        height: unset;
    }
    
    .homePage .fourthContent .imgInsta2{
        width: 39vw;
        height: unset;
    }
    
    .homePage .fourthContent .imgInsta3{
        width: 33vw;
        height: unset;
    }
    

    /* FASHION CONTENT */
    .homePage .FashionStars{
        position: relative;
        width: 90%;
        padding: 6% 3% 6% 3%;
    }

    .homePage .FashionStars .innerBorder {
        width: 96%;
        height: 98%;
    }

    .homePage .FashionStars .content {
       flex-direction: column;
    }

    .homePage .FashionStars .content1{
        width: 100%;
     }


    .homePage .FashionStars .logoFashion{
        width: 60%;
        aspect-ratio: 2.252 / 1;
        margin: 10px auto 20px auto;
    }

    .homePage .FashionStars .beneficiosCard{
        width: 98%;
        padding: 13px 3px 13px 10px;
    }

    .homePage .FashionStars .beneficio{
        max-width: 95%;
        width: 95%;
        /* display: list-item;
        text-align: -webkit-match-parent;
        unicode-bidi: isolate; */
    }
    


    

    /* FIFTH CONTENT */

    .homePage .fifthContent .imgEncontrarRevend{
        width: 95vw;
        aspect-ratio: 1 / 1.496;
        /* margin: 0% auto 0% auto; */
        background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat center/contain;
        transition: all 2s;
        cursor: pointer;
        margin: 0 auto;
    }


    /* SIXTH CONTENT */
    .homePage .sixthContent .lojaCards{
        display: flex;
        flex-direction: column;
    }

    .homePage .sixthContent .lojaCards .lojaCard {
        width: 100%;
        align-self: center;
        font-size: 0.9em;
    }

    .homePage .sixthContent .title{
        font-size: 1.7em;
    }
    
    .homePage .sixthContent .subtitle{
        font-size: 1em;
        width: 85%;
    }
    
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/homePage.css"],"names":[],"mappings":"AAAA,uBAAuB;;;AAIvB;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,6BAA6B;IAC7B,kCAAkC;AACtC;;;;AAIA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,8BAA8B;AAClC;;;;;;AAMA;IACI,WAAW;IACX,kCAAkC;IAClC,mCAAmC;IACnC,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,sCAAsC;AAC1C;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;IAClC,6BAA6B;IAC7B,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;IAGI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;;;AAIA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,4EAAiE;AACrE;;;;;;;;;AASA,mBAAmB;;AAEnB;IACI,aAAa;IACb,sCAAsC;IACtC,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,4EAAkE;AACtE;;AAEA;IACI,4EAAkE;AACtE;;;AAGA;IACI,4EAAkE;AACtE;;AAEA;IACI,4EAAkE;AACtE;;;;;AAKA,kBAAkB;;AAElB;IACI,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;;AAEvB;;;AAGA;IACI,UAAU;IACV,WAAW;IACX,kCAAkC;IAClC,+EAA+E;IAC/E,2BAA2B;AAC/B;;;;AAIA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;;;AAIA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;;;;;;;;AASA,kBAAkB;;AAElB;IACI,WAAW;IACX,uBAAuB;IACvB,kCAAkC;AACtC;;;AAGA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,wBAAwB;AAC5B;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,wBAAwB;AAC5B;;;;AAIA;IACI,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,4EAA6D;AACjE;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,4EAA6D;AACjE;;AAEA;IACI,YAAY;IACZ,4EAA6D;AACjE;;;;;AAKA,oBAAoB;;AAEpB;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,oBAAoB;IACpB,gBAAgB;IAChB,+CAA+C;IAC/C,yBAAyB;IACzB,cAAc;IACd,wBAAwB;IACxB,2BAA2B;IAC3B,8BAA8B;IAC9B,4BAA4B;AAChC;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,4EAAkF;IAClF,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;IAC5B,aAAa;AACjB;;;AAGA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,4EAA+E;IAC/E,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,kCAAkC;IAClC,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;;;;;;;AAQA,kBAAkB;;AAElB;IACI,WAAW;IACX,uBAAuB;IACvB,oBAAoB;AACxB;;;AAGA;IACI,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,6EAAwE;IACxE,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;;AAGA,kBAAkB;;AAElB;IACI,WAAW;IACX,uBAAuB;IACvB,oBAAoB;AACxB;;;AAGA;IACI,aAAa;IACb,kCAAkC;IAClC,8BAA8B;IAC9B,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;;AAGA;IACI,UAAU;IACV,sCAAsC;IACtC,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,6EAAkE;AACtE;;AAEA;IACI,kCAAkC;IAClC,4CAA4C;IAC5C,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,kCAAkC;IAClC,2CAA2C;IAC3C,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,2BAA2B;AAC/B;;;;;AAKA;IACI,2BAA2B;AAC/B;;AAEA;;AAEA;;;;AAIA;;IAEI;QACI,iBAAiB;QACjB,wCAAwC;QACxC,6BAA6B;QAC7B,kCAAkC;IACtC;;;;IAIA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,sBAAsB;QACtB,gCAAgC;QAChC,0BAA0B;QAC1B,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;OACG,SAAS;IACZ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;IACA;;QAEI,gBAAgB;QAChB,mBAAmB;IACvB;;;;;IAKA;;;;;QAKI,yBAAyB;IAC7B;;IAEA,mBAAmB;;IAEnB;QACI,aAAa;QACb,2BAA2B;QAC3B,mBAAmB;QACnB,UAAU;QACV,yBAAyB;QACzB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,YAAY;QACZ,qBAAqB;QACrB,kBAAkB;IACtB;;;;IAIA,kBAAkB;IAClB;QACI,aAAa;IACjB;;;IAGA;QACI,mCAAmC;QACnC,kCAAkC;QAClC,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;;;;;IAMA,UAAU;IACV;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,UAAU;QACV,wBAAwB;IAC5B;;;IAGA;QACI,WAAW;QACX,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;;IAGA,oBAAoB;IACpB;QACI,kBAAkB;QAClB,UAAU;QACV,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;OACG,sBAAsB;IACzB;;IAEA;QACI,WAAW;KACd;;;IAGD;QACI,UAAU;QACV,uBAAuB;QACvB,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,cAAc;QACd,UAAU;QACV;;gCAEwB;IAC5B;;;;;;IAMA,kBAAkB;;IAElB;QACI,WAAW;QACX,uBAAuB;QACvB,6BAA6B;QAC7B,6EAAyE;QACzE,kBAAkB;QAClB,eAAe;QACf,cAAc;IAClB;;;IAGA,kBAAkB;IAClB;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;AAEJ","sourcesContent":["/* MOVIMENTAÇÂO CARDS */\r\n@import url('https://fonts.googleapis.com/css2?family=Cardo:wght@700&family=Inter:wght@400;600&display=swap');\r\n\r\n\r\n.homePageBdy{\r\n    width: 100vw;\r\n    width: 100svw;\r\n    height: 100vh;\r\n    height: 100svh;\r\n    max-width: 100vw;\r\n    max-width: 100svw;\r\n    max-height: 100vh;\r\n    max-height: 100svh;\r\n    overflow-x: hidden;\r\n}\r\n.homePage{\r\n    min-height: 100vh;\r\n    background-color: var(--whiteMain-color);\r\n    color: var(--blackMain-color);\r\n    font-family: \"Poppins\", sans-serif;\r\n}\r\n\r\n\r\n\r\n.homePage .firstContent{\r\n    width: 100%;\r\n    height: 90vh;\r\n    max-height: 90vh;\r\n    display: grid;\r\n    grid-template-columns: 40% 60%;  \r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: 0 auto;\r\n    transition: 1s all ease-in-out;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.homePage .firstContent .logoText{\r\n    width: 100%;\r\n    font-family: \"Poppins\", sans-serif;\r\n    /* font-family: 'Cardo', 'serif'; */\r\n    font-weight: 700;\r\n    font-size: 2.5em;\r\n    transform: translateY(-30%);\r\n    text-align: end;\r\n}\r\n\r\n.homePage .firstContent .logo{\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: auto;\r\n}\r\n\r\n.homePage .firstContent .logoImg{\r\n    min-width: 65vh;\r\n    max-width: 65vh;\r\n    align-self: center;\r\n    aspect-ratio: 1 / 1.1513;\r\n    background: no-repeat center / contain;\r\n}\r\n\r\n\r\n.homePage .firstContent .sejaRevend{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    text-align: center;\r\n    align-items: center;\r\n    font-family: \"Poppins\", sans-serif;\r\n    color: var(--blackMain-color);\r\n    user-select: none;\r\n}\r\n\r\n.homePage .firstContent .sejaRevend .titleSide{\r\n    font-weight: 200;\r\n    font-size: 3.5em;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.homePage .firstContent .sejaRevend .subTitleSide{\r\n    font-weight: 700;\r\n    font-size: 3em;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.homePage .firstContent .btnCad,\r\n.homePage .btnCad,\r\n.homePage .buttonSaibaMais{\r\n    padding: 10px 30px;\r\n    font-weight: 700;\r\n    color: #FFFFFF;\r\n    background-color: var(--blackMain-color);\r\n    font-size: 2.3em;\r\n    width: fit-content;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    margin: 0 auto 10px auto;\r\n    text-align: center;\r\n}\r\n\r\n.homePage .buttonFacaParteFashion{\r\n    padding: 10px 30px;\r\n    font-weight: 700;\r\n    color: var(--blackMain-color);\r\n    background-color: #FFFFFF;\r\n    font-size: 1.6em;\r\n    width: fit-content;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    margin: 8px auto 10px auto;\r\n}\r\n\r\n\r\n\r\n.homePage .deslizeBaixo{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    font-family: 'Cardo', 'serif';\r\n    font-weight: 700;\r\n    font-size: 1.8em;\r\n    margin-top: 50px;\r\n    color: #0000007a;\r\n}\r\n\r\n\r\n.homePage .deslizeBaixo .imagemTextDwn{\r\n    min-width: 80px;\r\n    max-width: 80px;\r\n    align-self: center;\r\n    aspect-ratio: 1/1;\r\n    background: url('../imgs/ArrowDown.png') no-repeat center/contain;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* SECOND CONTENT */\r\n\r\n.homePage .secondContent{\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 1fr 1fr;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    margin: 3% auto 2% auto;\r\n    transition: all 2s;\r\n}\r\n\r\n.homePage .secondContent .cardBeneficio{\r\n    height: 20vw;\r\n    aspect-ratio: 1 / 1;\r\n    margin: 0% auto 2% auto;\r\n    transition: all 2s;\r\n}\r\n\r\n.homePage .secondContent .cardBeneficio1{\r\n    background: url('../imgs/beneficio1.png') no-repeat center/contain;\r\n}\r\n\r\n.homePage .secondContent .cardBeneficio2{\r\n    background: url('../imgs/beneficio2.png') no-repeat center/contain;\r\n}\r\n\r\n\r\n.homePage .secondContent .cardBeneficio3{\r\n    background: url('../imgs/beneficio3.png') no-repeat center/contain;\r\n}\r\n\r\n.homePage .secondContent .cardBeneficio4{\r\n    background: url('../imgs/beneficio4.png') no-repeat center/contain;\r\n}\r\n\r\n\r\n\r\n\r\n/* THIRD CONTENT */\r\n\r\n.homePage .thirdContent{\r\n    width: 92%;\r\n    margin: 0px auto 50px auto;\r\n}\r\n\r\n.homePage .thirdContent p{\r\n    font-family: 'Cardo', 'serif';\r\n    font-size: 2em;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.homePage .thirdContent .title{\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-size: 2.3em;\r\n    font-weight: 700;\r\n    /* text-align: center; */\r\n}\r\n\r\n.homePage .thirdContent .subTitle{\r\n    font-weight: 700;\r\n}\r\n\r\n.homePage .thirdContent .text{\r\n    font-weight: 500;\r\n    margin-bottom: 15px;\r\n    \r\n}\r\n\r\n\r\n.homePage  .divisorHome{\r\n    width: 80%;\r\n    height: 1px;\r\n    background: var(--blackMain-color);\r\n    background: linear-gradient(90deg, #27313733 0%, #27313766 50%, #27313733 100%);\r\n    margin: 30px auto 20px auto;\r\n}\r\n\r\n\r\n\r\n.homePage  .divisorHome1{\r\n    margin: 30px auto 20px auto;\r\n}\r\n\r\n.homePage  .divisorHome2{\r\n    margin: 30px auto 20px auto;\r\n}\r\n\r\n\r\n\r\n.homePage .buttonSaibaMais{\r\n    padding: 10px 30px;\r\n    font-weight: 700;\r\n    color: #FFFFFF;\r\n    background-color: var(--blackMain-color);\r\n    font-size: 1.3em;\r\n    width: fit-content;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    margin: 5px auto 10px auto;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* FOURTH CONTENT*/\r\n\r\n.homePage .fourthContent{\r\n    width: 100%;\r\n    margin: 5% auto 2% auto;\r\n    font-family: \"Poppins\", sans-serif;\r\n}\r\n\r\n\r\n.homePage .fourthContent .title{\r\n    font-weight: 700;\r\n    font-size: 2em;\r\n    text-align: center;\r\n    width: 92%;\r\n    margin: 0 auto 20px auto;\r\n}\r\n\r\n\r\n.homePage .fourthContent .contents{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 80%;\r\n    margin: 20px auto 0 auto;\r\n}\r\n\r\n\r\n\r\n.homePage .fourthContent .imgInsta{\r\n    height: 25vw;\r\n    aspect-ratio: 1 / 1;\r\n    /* margin: 0% auto 0% auto; */\r\n    transition: all 2s;\r\n    cursor: pointer;\r\n}\r\n\r\n.homePage .fourthContent .imgInsta1{\r\n    height: 20vw;\r\n    background: url('../imgs/post1.jpg') no-repeat center/contain;\r\n}\r\n\r\n.homePage .fourthContent .imgInsta2{\r\n    height: 30vw;\r\n    aspect-ratio: 1 / 1.777;\r\n    background: url('../imgs/post2.jpg') no-repeat center/contain;\r\n}\r\n\r\n.homePage .fourthContent .imgInsta3{\r\n    height: 20vw;\r\n    background: url('../imgs/post3.jpg') no-repeat center/contain;\r\n}\r\n\r\n\r\n\r\n\r\n/* FASHION CONTENT */\r\n\r\n.homePage .FashionStars{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: relative;\r\n    width: 60%;\r\n    margin: 5% auto 2% auto;\r\n    transition: all 0.5s;\r\n    overflow: hidden;\r\n    background-color: var(--black-experience-color);\r\n    border: 3px solid #FFFFFF;\r\n    color: #FFFFFF;\r\n    padding: 50px 3% 50px 3%;\r\n    margin: 25px auto 15px auto;\r\n    transition: all 1s ease-in-out;\r\n    transform: translateX(-100%);\r\n}\r\n\r\n\r\n.homePage .FashionStars.viewCardFashion{\r\n    transform: translateX(0%);\r\n}\r\n\r\n.homePage .FashionStars .content{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 80%;\r\n}\r\n\r\n.homePage .FashionStars .innerBorder{\r\n    position: absolute;\r\n    width: 99%;\r\n    border: 3px solid #FFFFFF;\r\n    z-index: 10;\r\n    height: 97%;\r\n}\r\n\r\n\r\n.homePage .FashionStars .starExperience{\r\n    position: absolute;\r\n    width: var(--sizeBubble);\r\n    aspect-ratio: 1/1;\r\n    background: url('../imgs/fashionStar/starExperience.png') no-repeat center/contain;\r\n    top: var(--topBubble);\r\n    left: var(--leftBubble);\r\n    bottom: var(--bottomBubble);\r\n    right: var(--rightBubble);\r\n    z-index: 102;\r\n    z-index: var(--zIndexBubble);\r\n    opacity: 100%;\r\n}\r\n\r\n\r\n.homePage .FashionStars .content{\r\n    position: relative;\r\n    z-index: 110;\r\n}\r\n\r\n.homePage .FashionStars .logoFashion{\r\n    width: 20vw;\r\n    aspect-ratio: 2.252 / 1;\r\n    background: url('../imgs/fashionStar/LogoFshionW.png') no-repeat center/contain;\r\n    margin: 0px auto 0px auto;\r\n}\r\n\r\n.homePage .FashionStars .titleFashion{\r\n    width: 95%;\r\n    margin: 0 auto 0px auto;\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-size: 1.2em;\r\n    font-weight: 700;\r\n    text-align: center;\r\n}\r\n\r\n.homePage .FashionStars .subTitle{\r\n    width: 90%;\r\n    margin: 0 auto 10px auto;\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-size: 1em;\r\n    font-weight: 400;\r\n    text-align: center;\r\n}\r\n\r\n.homePage .FashionStars .beneficiosCard{\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    text-align: left;\r\n    padding: 13px 10px;\r\n    background-color: #332e309d;\r\n    border: 1px solid #FFFFFF;\r\n    margin: 0 auto;\r\n}\r\n\r\n.homePage .FashionStars .beneficio{\r\n    display: flex;\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-size: 1em;\r\n    font-weight: 400;\r\n    color: #E3E3E3;\r\n    margin: 5px 0;\r\n    max-width: 95%;\r\n}\r\n\r\n\r\n.homePage .FashionStars .beneficio.mid{\r\n    font-weight: 600;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.homePage .FashionStars .beneficio.max{\r\n    font-weight: 800;\r\n    color: #FFFFFF;\r\n}\r\n\r\n\r\n.homePage .FashionStars .obs{\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-size: 0.9em;\r\n    font-weight: 400;\r\n    color: #FFFFFF;\r\n    margin-top: 10px;\r\n    text-align: center;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* FIFTH CONTENT */\r\n\r\n.homePage .fifthContent{\r\n    width: 100%;\r\n    margin: 5% auto 2% auto;\r\n    transition: all 0.5s;\r\n}\r\n\r\n\r\n.homePage .fifthContent .imgEncontrarRevend{\r\n    width: 85vw;\r\n    aspect-ratio: 3 / 1;\r\n    /* margin: 0% auto 0% auto; */\r\n    background: url('../imgs/encontraRevendPc.png') no-repeat center/contain;\r\n    transition: all 2s;\r\n    cursor: pointer;\r\n    margin: 0 auto;\r\n}\r\n\r\n\r\n/* SIXTH CONTENT */\r\n\r\n.homePage .sixthContent{\r\n    width: 100%;\r\n    margin: 5% auto 2% auto;\r\n    transition: all 0.5s;\r\n}\r\n\r\n\r\n.homePage .sixthContent .lojaCards{\r\n    display: grid;\r\n    grid-template-columns: 30% 30% 30%;\r\n    justify-content: space-between;\r\n    grid-gap: 50px 0;\r\n    width: 75%;\r\n    margin: 0 auto;\r\n    margin-bottom: 60px;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.homePage .sixthContent .lojaCards .lojaCard{\r\n    width: 90%;\r\n    border: 2px solid var(--colorLojaCard);\r\n    border-radius: 5px;\r\n    padding: 0px 20px 30px 20px;\r\n}\r\n\r\n.homePage .sixthContent .lojaCards .topCard{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 20px 0;\r\n}\r\n\r\n.homePage .sixthContent .lojaCards .logo{\r\n    min-width: 20%;\r\n    max-width: 20%;\r\n    aspect-ratio: 350/111;\r\n    background: url('../imgs/LogoRotate.svg') no-repeat center/contain;\r\n}\r\n\r\n.homePage .sixthContent .lojaCards .lojaTitle{\r\n    font-family: \"Poppins\", sans-serif;\r\n    /* font-family: \"Playfair Display\", serif; */\r\n    font-weight: 600;\r\n    font-size: 1.5em;\r\n    margin: 0;\r\n    color: var(--colorLojaCard);\r\n}\r\n\r\n.homePage .sixthContent .lojaCards .infoLoja{\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-weight: 300;\r\n    font-size: 1.1em;\r\n    margin: 0;\r\n}\r\n\r\n.homePage .sixthContent{\r\n    font-family: \"Poppins\", sans-serif;\r\n    /* font-family: \"Montserrat\", sans-serif; */\r\n    font-weight: 500;\r\n    color: var(--blackMain-color);\r\n}\r\n\r\n.homePage .sixthContent .title{\r\n    font-weight: 700;\r\n    font-size: 2em;\r\n    text-align: center;\r\n}\r\n\r\n.homePage .sixthContent .subtitle{\r\n    font-size: 1.3em;\r\n    width: 75%;\r\n    margin: 15px auto 20px auto;\r\n}\r\n\r\n\r\n\r\n\r\n.homePage  .divisorHome5{\r\n    margin: 30px auto 20px auto;\r\n}\r\n\r\n@media(max-width: 1400px){\r\n\r\n}\r\n\r\n\r\n\r\n@media(max-width: 767px){\r\n\r\n    .homePage{\r\n        min-height: 100vh;\r\n        background-color: var(--whiteMain-color);\r\n        color: var(--blackMain-color);\r\n        font-family: \"Poppins\", sans-serif;\r\n    }\r\n    \r\n    \r\n    \r\n    .homePage .firstContent {\r\n        display: flex;\r\n        flex-direction: column-reverse;\r\n        height: fit-content;\r\n        /* min-height: 88vh; */\r\n        /* margin: 30px auto 8vh auto; */\r\n        margin: 0px auto 50px auto;\r\n        justify-content: flex-end;\r\n        padding-top: 4vh;\r\n    }\r\n\r\n    .homePage .firstContent .logoImg {\r\n        min-width: 35vh;\r\n        max-width: 35vh;\r\n    }\r\n\r\n    .homePage .firstContent .logo {\r\n       margin: 0;\r\n    }\r\n\r\n    .homePage .firstContent .sejaRevend .titleSide {\r\n        font-size: 1.7em;\r\n    }\r\n\r\n    .homePage .firstContent .sejaRevend .subTitleSide {\r\n        font-size: 1em;\r\n        width: 80%;\r\n    }\r\n    .homePage .firstContent .btnCad,\r\n    .homePage .btnCad{\r\n        font-size: 1.1em;\r\n        margin-bottom: 30px;\r\n    }\r\n\r\n\r\n\r\n\r\n    .homePage  .divisorHome1,\r\n    .homePage  .divisorHome2,\r\n    .homePage  .divisorHome3,\r\n    .homePage  .divisorHome4,\r\n    .homePage  .divisorHome5{\r\n        margin: 0px auto 5px auto;\r\n    }\r\n\r\n    /* SECOND CONTENT */\r\n\r\n    .homePage .secondContent{\r\n        display: flex;\r\n        justify-content: flex-start;\r\n        align-items: center;\r\n        width: 95%;\r\n        margin: 3% auto 50px auto;\r\n        transition: all 2s;\r\n        overflow-x: scroll;\r\n    }\r\n    \r\n    .homePage .secondContent .cardBeneficio {\r\n        aspect-ratio: 44 / 65;\r\n        height: 75vw;\r\n        margin: 0% 5px 0% 5px;\r\n        transition: all 2s;\r\n    }\r\n\r\n\r\n\r\n    /* THIRD CONTENT */\r\n    .homePage .thirdContent{\r\n        margin-top: 0;\r\n    }\r\n\r\n\r\n    .homePage .thirdContent p{\r\n        /* font-family: 'Cardo', 'serif'; */\r\n        font-family: \"Poppins\", sans-serif;\r\n        font-size: 1.2em;\r\n    }\r\n\r\n    .homePage .thirdContent .title{\r\n        margin-bottom: 5px;\r\n    }\r\n\r\n    \r\n\r\n\r\n \r\n    /* FORTH */\r\n    .homePage .fourthContent .title{\r\n        text-align: center;\r\n    }\r\n\r\n    .homePage .fourthContent .title{\r\n        font-weight: 700;\r\n        font-size: 2em;\r\n        text-align: center;\r\n        width: 92%;\r\n        margin: 0 auto 20px auto;\r\n    }\r\n    \r\n    \r\n    .homePage .fourthContent .contents{\r\n        width: 100%;\r\n        margin: 20px auto 0 auto;\r\n    }\r\n\r\n    .homePage .fourthContent .imgInsta{\r\n        height: unset;\r\n    }\r\n\r\n    .homePage .fourthContent .imgInsta1{\r\n        width: 33vw;\r\n        height: unset;\r\n    }\r\n    \r\n    .homePage .fourthContent .imgInsta2{\r\n        width: 39vw;\r\n        height: unset;\r\n    }\r\n    \r\n    .homePage .fourthContent .imgInsta3{\r\n        width: 33vw;\r\n        height: unset;\r\n    }\r\n    \r\n\r\n    /* FASHION CONTENT */\r\n    .homePage .FashionStars{\r\n        position: relative;\r\n        width: 90%;\r\n        padding: 6% 3% 6% 3%;\r\n    }\r\n\r\n    .homePage .FashionStars .innerBorder {\r\n        width: 96%;\r\n        height: 98%;\r\n    }\r\n\r\n    .homePage .FashionStars .content {\r\n       flex-direction: column;\r\n    }\r\n\r\n    .homePage .FashionStars .content1{\r\n        width: 100%;\r\n     }\r\n\r\n\r\n    .homePage .FashionStars .logoFashion{\r\n        width: 60%;\r\n        aspect-ratio: 2.252 / 1;\r\n        margin: 10px auto 20px auto;\r\n    }\r\n\r\n    .homePage .FashionStars .beneficiosCard{\r\n        width: 98%;\r\n        padding: 13px 3px 13px 10px;\r\n    }\r\n\r\n    .homePage .FashionStars .beneficio{\r\n        max-width: 95%;\r\n        width: 95%;\r\n        /* display: list-item;\r\n        text-align: -webkit-match-parent;\r\n        unicode-bidi: isolate; */\r\n    }\r\n    \r\n\r\n\r\n    \r\n\r\n    /* FIFTH CONTENT */\r\n\r\n    .homePage .fifthContent .imgEncontrarRevend{\r\n        width: 95vw;\r\n        aspect-ratio: 1 / 1.496;\r\n        /* margin: 0% auto 0% auto; */\r\n        background: url('../imgs/encontraRevendMob.png') no-repeat center/contain;\r\n        transition: all 2s;\r\n        cursor: pointer;\r\n        margin: 0 auto;\r\n    }\r\n\r\n\r\n    /* SIXTH CONTENT */\r\n    .homePage .sixthContent .lojaCards{\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .homePage .sixthContent .lojaCards .lojaCard {\r\n        width: 100%;\r\n        align-self: center;\r\n        font-size: 0.9em;\r\n    }\r\n\r\n    .homePage .sixthContent .title{\r\n        font-size: 1.7em;\r\n    }\r\n    \r\n    .homePage .sixthContent .subtitle{\r\n        font-size: 1em;\r\n        width: 85%;\r\n    }\r\n    \r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
